<template>
  <tr v-if="show">
    <th :colspan="colspan">
      <span  style="color: rgba(0, 0, 0, 0.38); font-size: 0.875rem; font-weight: 400;">No data available</span>
    </th>
  </tr>

</template>
<script>
export default {
  name: 'NoDataInDataTable',
  props: {
    colspan: {},
    show: {}
  }
}
</script>